/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_ColorInputs */

const en_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Color`)
};

const es_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color de texto`)
};

const fr_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur du texte`)
};

const de_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textfarbe`)
};

const ja_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの色`)
};

const zh_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本颜色`)
};

const ar_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لون النص`)
};

const id_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna Teks`)
};

const it_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore del testo`)
};

const ru_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет текста`)
};

const pt_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor do texto`)
};

const ko_text_color = /** @type {(inputs: Text_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`텍스트 색상`)
};

/**
* | output |
* | --- |
* | "Text Color" |
*
* @param {Text_ColorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const text_color = /** @type {((inputs?: Text_ColorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_ColorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_text_color(inputs)
	if (locale === "es") return es_text_color(inputs)
	if (locale === "fr") return fr_text_color(inputs)
	if (locale === "de") return de_text_color(inputs)
	if (locale === "ja") return ja_text_color(inputs)
	if (locale === "zh") return zh_text_color(inputs)
	if (locale === "ar") return ar_text_color(inputs)
	if (locale === "id") return id_text_color(inputs)
	if (locale === "it") return it_text_color(inputs)
	if (locale === "ru") return ru_text_color(inputs)
	if (locale === "pt") return pt_text_color(inputs)
	return ko_text_color(inputs)
});